import CoreLayout from "../../components/layout/CoreLayout";
import PageContainer from "../../components/PageContainer";
import PageHeader from "../../components/PageHeader";
import TransferRulesEditor from "../../components/TransferRulesEditor";
import { usePageTitle } from "../../lib/usePageTitle";

function getCustomerId(): string | null {
  return (
    localStorage.getItem("customerId") || sessionStorage.getItem("customerId")
  );
}

export default function Transfer() {
  usePageTitle("Transfer");
  const customerId = getCustomerId();

  return (
    <CoreLayout>
      <PageContainer>
        <PageHeader
          title="Transfer"
          subtitle="Where calls go when your receptionist hands them off."
        />

        {customerId ? (
          <TransferRulesEditor customerId={customerId} />
        ) : (
          <div className="text-center py-12">
            <i className="ri-error-warning-line text-5xl text-purple-400/30 mb-5 block" />
            <p
              className="text-gray-400"
              style={{ fontFamily: "'Space Grotesk', sans-serif" }}
            >
              No customer ID found. Please log in again to configure
              transfer rules.
            </p>
          </div>
        )}
      </PageContainer>
    </CoreLayout>
  );
}
